import { useTranslation } from 'react-i18next';
import useSettings from './useSettings';
// config
import { allLangs, defaultLang } from '../config';
import { useCallback } from 'react';

const useLocales = () => {
    const { i18n, t: translate } = useTranslation();

    const { onChangeDirectionByLang } = useSettings();

    const currentLang = allLangs.find((_lang) => _lang.value === i18n.language) ?? defaultLang;

    const changeLanguage = useCallback(
        async (locale: string) => {
            await i18n.changeLanguage(locale);
            onChangeDirectionByLang(locale);
        },
        [i18n, onChangeDirectionByLang]
    );

    return {
        changeLanguage,
        translate,
        currentLang,
        allLangs,
    };
};

export default useLocales;
